import type { Theme } from '@mui/material';
import { Button, Typography } from '@mui/material';
import type { StyleRules, WithStyles } from '@mui/styles';
import withStyles from '@mui/styles/withStyles';
import giftWalletLogo from '../../assets/images/giftWalletLogo.svg';

const styles = (theme: Theme): StyleRules => {
  const GIFT_WALLET_LOGO_WIDTH = 24;
  const BUTTON_BORDER_COLOR = '#F7F7F7';
  const BUTTON_BACKGROUND_COLOR = {
    base: '#232323',
    hover: '#FFFFFF',
    click: '#F7F7F7'
  };
  const BUTTON_TEXT_COLOR = {
    base: '#FFFFFF',
    hover: '#232323',
    click: '#232323'
  };

  return {
    saveGiftCardButton: {
      display: 'flex',
      height: theme.spacing(6),
      padding: theme.spacing(0, 2),
      justifyContent: 'center',
      alignItems: 'center',
      gap: theme.spacing(1),
      border: `2px solid ${BUTTON_BORDER_COLOR}`,
      borderRadius: theme.spacing(1),
      backgroundColor: BUTTON_BACKGROUND_COLOR.base,
      color: BUTTON_TEXT_COLOR.base,
      textTransform: 'none', // MUI の Button はデフォルトで大文字になるため解除

      '&:hover': {
        borderColor: BUTTON_BORDER_COLOR,
        backgroundColor: BUTTON_BACKGROUND_COLOR.hover,
        color: BUTTON_TEXT_COLOR.hover
      },

      '&:active': {
        borderColor: BUTTON_BORDER_COLOR,
        backgroundColor: BUTTON_BACKGROUND_COLOR.click,
        color: BUTTON_TEXT_COLOR.click
      }
    },
    giftWalletLogo: {
      width: GIFT_WALLET_LOGO_WIDTH,
      height: GIFT_WALLET_LOGO_WIDTH
    },
    saveGiftCardText: {
      fontWeight: 'bold'
    }
  };
};

type GiftWalletOwnProps = {
  handleGiftWalletButtonClick?: () => void;
};

type GiftWalletButtonProps = GiftWalletOwnProps & WithStyles<typeof styles>;

const GiftWalletButton: React.FC<GiftWalletButtonProps> = ({
  classes,
  handleGiftWalletButtonClick
}) => {
  const handleOnClick = () => {
    if (handleGiftWalletButtonClick) {
      handleGiftWalletButtonClick();
    }
  };

  return (
    <>
      <Button
        className={classes.saveGiftCardButton}
        onClick={() => handleOnClick()}
        data-cy="giftWalletButton"
      >
        <img
          src={giftWalletLogo}
          className={classes.giftWalletLogo}
          alt="gift wallet ロゴ"
          data-cy="giftWalletLogo"
        />
        <Typography variant="body1" className={classes.saveGiftCardText}>
          gift wallet に保存する
        </Typography>
      </Button>
    </>
  );
};

export default withStyles(styles)(GiftWalletButton);
